import React from 'react';
import { MessageCircle } from 'lucide-react';
import { trackLead } from '../lib/metaPixel';
export function StickyButtons() {
  return <a href="https://wa.link/qca29f" target="_blank" rel="noreferrer" onClick={trackLead} aria-label="Contact Blu Ocean Tours on WhatsApp" className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white py-3 pl-4 pr-3 font-semibold shadow-lg transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#25D366]" data-id="element-141">
      <span className="hidden sm:inline" data-id="element-142">Blu Ocean Tours</span>
      <MessageCircle size={26} aria-hidden="true" data-id="element-143" />
    </a>;
}